import { useState } from 'preact/hooks'
import { initialsOf } from '@/components/console/initials'

interface SpeakerAvatarProps {
    name: string
    photoUrl: string | null
    /** Its size, beside the round `vav` every avatar shares. */
    className: string
}

/** The speaker's headshot when the page was baked with one, their initials when not or when it fails to load. */
export function SpeakerAvatar({ name, photoUrl, className }: SpeakerAvatarProps) {
    const [failed, setFailed] = useState(false)
    if (photoUrl && !failed) return <img class={`vav ${className}`} src={photoUrl} alt="" onError={() => setFailed(true)} />
    return <span class={`vav ${className}`} aria-hidden="true">{initialsOf(name)}</span>
}
